export default __webpack_public_path__ + "static/media/My pic.d59e1c2f.jpg";